import convertVideoLink from "../assets/store/convertVideoLinktoEmbed";
import { findLinkByName } from "../assets/store/findLink";

const renderVideoRows = () => {
    const rows = document.getElementsByClassName("ds-video-row");
    const drive_service_divs = window.DriveServiceSpecials.drive_service_divs;
    const client = window.DriveServiceSpecials.client;
    const { isMobile } = window?.window?.deviceDetect?.getWindowData();

    const setUpIframe = (el, width, height, link) => {
        el.style.width = width ?? "100%";
        el.style.height = height ?? "100%";
        el.style.display = "block";
        el.style.margin = "0 auto";
        el.style.border = "none";
        el.src = link;
    };

    const { links, name: client_name, enable_interactive_video } = client;

    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const parent = drive_service_divs.find(
            (div) =>
                div.id === parseInt(row.parentElement.id.replace("ds-div-", ""))
        );
        const rowData = parent.div_rows.find(
            (rowObj) => rowObj.id === parseInt(row.id)
        );
        let {
            embedded_media,
            media_height,
            media_width,
            use_interactive_video,
        } = rowData;
        let convertedLink = convertVideoLink(embedded_media);
        let iframeWrapper = document.createElement("div");
        let iframe = document.createElement("iframe");
        let interactiveLink = findLinkByName({
            links,
            linkType: `${client_name} ${
                isMobile ? "Mobile" : "Desktop"
            } Interactive Video`,
        });
        interactiveLink = interactiveLink
            ? interactiveLink.link + "?muted=1&autoplay=1"
            : null;
        iframeWrapper.style.height = "550px";
        setUpIframe(
            iframe,
            media_width,
            media_height,
            use_interactive_video && interactiveLink
                ? interactiveLink
                : convertedLink
        );
        iframeWrapper.appendChild(iframe);
        if (
            use_interactive_video &&
            enable_interactive_video &&
            interactiveLink &&
            row.childNodes.length === 0
        )
            row.appendChild(iframeWrapper);
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderVideoRows();
window.renderVideoRows = renderVideoRows;

export default renderVideoRows;
